import { motion } from 'framer-motion';
export function OutcomeCard({ number, title, description, delay = 0 }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      // viewport={{ once: true, margin: "-50px" }}
      whileHover={{ 
        scale: 1.02,
        transition: { duration: 0.2, ease: [0.22, 1, 0.36, 1] }
      }}
      transition={{ 
        duration: 0.5, 
        delay,
        ease: [0.22, 1, 0.36, 1]
      }}
      className="flex items-start gap-4 px-8 py-8 rounded-2xl item-border border-white/10 bg-gradient-to-br from-white/5 to-transparent backdrop-blur-sm transition-all hover:border-white/20 hover:shadow-lg hover:shadow-primary/5"
    >
      <div className="flex items-center justify-center w-10 h-10 flex-shrink-0 rounded-full bg-primary/20">
        <span className="text-[#FD5B38] text-lg font-normal">{number}</span>
      </div>
      <div className="flex flex-col gap-2">
        <h3 className="text-white text-xl sm:text-2xl font-normal leading-snug">
          {title}
        </h3>
        <p className="text-muted-foreground text-base leading-relaxed">
          {description}
        </p>
      </div>
    </motion.div>
  );
}
